import { ActionButton } from '@/components/Common/Dialog';
import { BLACK, CUSTOM_SCROLL } from '@/styles/common.styled';
import styled from 'vue-styled-components';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
`;

export const Desc = styled.p`
    width: 100%;
    color: #2a333d;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
`;

export const CTAWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    margin: 0 -28px;
    padding: 16px 28px;
    gap: 8px;
    border-top: 1px solid #d4d8db;
`;

export const CancelActionButton = styled(ActionButton)`
    color: ${BLACK(100)};
    background: unset;
    &:hover,
    &:active {
        background-color: #f7f7f7;
    }
`;

export const ListSelectHeader = styled.div`
    width: 100%;
    height: 42px;
    display: flex;
    gap: 8px;
    align-items: center;
    color: #080a0d;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    border-bottom: 1px solid #dfe3e5;
    background-color: #f4f6f8;
    padding: 12px 16px;
    border: 1px solid #dfe3e5;
    margin-top: 20px;
    border-radius: 2px 2px 0 0;
`;

export const ListSelectWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    margin: 0 0 27px 0;
    border-radius: 0 0 2px 2px;
    border: 1px solid #dfe3e5;
    border-top: none;
    background-color: #fff;
    overflow-y: auto;
    ${CUSTOM_SCROLL}
    position: relative;
    border-radius: 0 0 2px 2px;
    padding: 16px;
`;

export const LabelFor = styled.span`
    cursor: pointer;
    user-select: none;
`;

export const ListSelectContent = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 2px;
    width: 100%;
`;

export const ListSelectItem = styled('li', {
    isSelected: Boolean,
})`
    width: 100%;
    display: flex;
    gap: 8px;
    padding: 10px 12px;
    align-items: center;
    color: #000;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    cursor: pointer;

    background-color: ${({ isSelected }) =>
        isSelected ? '#FAFBFC' : 'transparent'};
`;
